import React from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const NavigateToHome = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate("/");
  }, []);

  return <div>Please Login.</div>;
};

export default NavigateToHome;
